var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTerrenoBaldioIcone = function SvgTerrenoBaldioIcone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2V4H8V2C8 0.895431 8.89543 0 10 0C11.1046 0 12 0.895431 12 2V4H16V2C16 0.895431 16.8954 0 18 0C19.1046 0 20 0.895431 20 2V19C20 19.5523 19.5523 20 19 20H17C16.4477 20 16 19.5523 16 19V18H12V19C12 19.5523 11.5523 20 11 20H9C8.44771 20 8 19.5523 8 19V18H4V19C4 19.5523 3.55228 20 3 20H1C0.447715 20 0 19.5523 0 19V2ZM4 15H8V7H4V15ZM12 15H16V7H12V15Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTerrenoBaldioIcone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/terreno-baldio-icone.58310b21.svg";
export { ForwardRef as ReactComponent };